import { render, staticRenderFns } from "./ClientRights.vue?vue&type=template&id=604fe27c&scoped=true&"
import script from "./ClientRights.vue?vue&type=script&lang=js&"
export * from "./ClientRights.vue?vue&type=script&lang=js&"
import style0 from "./ClientRights.vue?vue&type=style&index=0&id=604fe27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604fe27c",
  null
  
)

export default component.exports